import React, { Component } from 'react';
import { FormattedMessage } from "react-intl";
import { BaseCombobox } from '../controls/BaseCombobox';

export class ProductCategorySelect extends Component {
    constructor(props) {
        super(props);

        this.handleValueSeleted = this.handleValueSeleted.bind(this);
    }

    handleValueSeleted(e) {
        var handler = this.props.onValueSeleted;
        if (handler) {
            handler(parseInt(e.target.value));
        }
    }

    render() {
        return (
            <BaseCombobox onChangeCapture={this.handleValueSeleted}>
                    <FormattedMessage id="CustomMade">
                        {text => <option value="0">{text}</option>}
                    </FormattedMessage>
                    <FormattedMessage id="Eardrum">
                        {text => <option value="1">{text}</option>}
                    </FormattedMessage>
            </BaseCombobox>
        );
    }
}



